module.exports = __webpack_public_path__ + "img/fake-user-5.0d742d4f.png";